<template>
	<div>
		<div v-if="loading>0">
			Loading...
		</div>
		<div v-else-if="user">
			<h2>Billing</h2>
			<b-form-row class="mb-3">
				<b-col>
					<b-input-group size="lg" prepend="Status"><b-form-input readonly v-model="user.subscription_status" :state="!!user.is_subscribed"></b-form-input></b-input-group>
				</b-col>
				<b-col>
					<b-input-group size="lg" prepend="Plan"><b-form-input readonly v-model="user.plan"></b-form-input></b-input-group>
				</b-col>
				<b-col>
					<b-input-group size="lg" prepend="Period"><b-form-input readonly v-model="user.period"></b-form-input></b-input-group>
				</b-col>
				<b-col v-if="user.is_subscribed && user.subscription_status != 'gratuity'">
					<b-button block size="lg" variant="danger" @click="$refs.cancelModal.show()">Cancel subscription</b-button>
				</b-col>
			</b-form-row>
			<h2>Plans</h2>
			<table class="table table-sm">
				<thead>
					<tr>
						<th style="width: 16%" rowspan="2"></th>
						<th colspan="2" :class="{'table-secondary': user.is_regular, 'text-secondary': user.is_regular, 'text-center': true}">Regular</th>
						<th colspan="2" :class="{'table-secondary': user.is_pro, 'text-secondary': user.is_pro, 'text-center': true}">Pro</th>
					</tr>
					<tr>
						<th style="width: 21%" :class="{'table-secondary': user.is_regular && user.is_monthly, 'text-secondary': user.is_regular && user.is_monthly, 'text-center': true}">$4/month</th>
						<th style="width: 21%" :class="{'table-secondary': user.is_regular && user.is_yearly, 'text-secondary': user.is_regular && user.is_yearly, 'text-center': true}">$40/year</th>
						<th style="width: 21%" :class="{'table-secondary': user.is_pro && user.is_monthly, 'text-secondary': user.is_pro && user.is_monthly, 'text-center': true}">$8/month</th>
						<th style="width: 21%" :class="{'table-secondary': user.is_pro && user.is_yearly, 'text-secondary': user.is_pro && user.is_yearly, 'text-center': true}">$80/year</th>
					</tr>
					<tr v-if="user.is_regular || user.is_pro">
						<th></th>
						<th :class="{'table-secondary': user.is_regular && user.is_monthly, 'text-secondary': user.is_regular && user.is_monthly, 'text-center': true}">{{user.is_regular && user.is_monthly ? 'Your current plan' : ''}}</th>
						<th :class="{'table-secondary': user.is_regular && user.is_yearly, 'text-secondary': user.is_regular && user.is_yearly, 'text-center': true}">{{user.is_regular && user.is_yearly ? 'Your current plan' : ''}}</th>
						<th :class="{'table-secondary': user.is_pro && user.is_monthly, 'text-secondary': user.is_pro && user.is_monthly, 'text-center': true}">{{user.is_pro && user.is_monthly ? 'Your current plan' : ''}}</th>
						<th :class="{'table-secondary': user.is_pro && user.is_yearly, 'text-secondary': user.is_pro && user.is_yearly, 'text-center': true}">{{user.is_pro && user.is_yearly ? 'Your current plan' : ''}}</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th>
							Combined chats
						</th>
						<td colspan="2" :class="{'table-secondary': user.is_regular, 'text-secondary': user.is_regular}">
							Unlimited
						</td>
						<td colspan="2" :class="{'table-secondary': user.is_pro, 'text-secondary': user.is_pro}">
							Unlimited
						</td>
					</tr>
					<tr>
						<th>
							Available widgets
						</th>
						<td colspan="2" :class="{'table-secondary': user.is_regular, 'text-secondary': user.is_regular}">
							<a href="#">Chat</a>, <a href="#">Viewer count</a>, <a href="#">Highlighted message</a>
						</td>
						<td colspan="2" :class="{'table-secondary': user.is_pro, 'text-secondary': user.is_pro}">
							All widgets from Regular, plus: <a href="#">Word cloud</a>
						</td>
					</tr>
					<tr>
						<th>
							Text to speech
						</th>
						<td colspan="2" :class="{'table-secondary': user.is_regular, 'text-secondary': user.is_regular}">
							Over 290 voices <a :href="`${$baseUrl}/voices/regular`">voice list</a>
						</td>
						<td colspan="2" :class="{'table-secondary': user.is_pro, 'text-secondary': user.is_pro}">
							Over 1300 voices <a :href="`${$baseUrl}/voices/pro`">voice list</a>
						</td>
					</tr>
					<tr>
						<th>
							Restreaming
						</th>
						<td colspan="2" :class="{'table-secondary': user.is_regular, 'text-secondary': user.is_regular}">
							No
						</td>
						<td colspan="2" :class="{'table-secondary': user.is_pro, 'text-secondary': user.is_pro}">
							Yes <small>(Experimental)</small>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<th rowspan="2"></th>
						<th :class="{'table-secondary': user.is_regular && user.is_monthly, 'text-secondary': user.is_regular && user.is_monthly, 'text-center': true}">$4/month</th>
						<th :class="{'table-secondary': user.is_regular && user.is_yearly, 'text-secondary': user.is_regular && user.is_yearly, 'text-center': true}">$40/year</th>
						<th :class="{'table-secondary': user.is_pro && user.is_monthly, 'text-secondary': user.is_pro && user.is_monthly, 'text-center': true}">$8/month</th>
						<th :class="{'table-secondary': user.is_pro && user.is_yearly, 'text-secondary': user.is_pro && user.is_yearly, 'text-center': true}">$80/year</th>
					</tr>
					<tr>
						<th :class="{'table-secondary': user.is_regular && user.is_monthly, 'text-secondary': user.is_regular && user.is_monthly, 'text-center': true}">
							<b-button variant="danger" v-if="user.is_regular && user.is_monthly && user.subscription_status != 'gratuity'" @click="$refs.cancelModal.show()">Cancel subscription</b-button>
							<b-button variant="primary" v-else-if="!user.is_subscribed || user.subscription_status == 'gratuity'" @click="$refs.purchaseModal.show('regular', 'monthly')">Buy monthly</b-button>
						</th>
						<th :class="{'table-secondary': user.is_regular && user.is_yearly, 'text-secondary': user.is_regular && user.is_yearly, 'text-center': true}">
							<b-button variant="danger" v-if="user.is_regular && user.is_yearly && user.subscription_status != 'gratuity'" @click="$refs.cancelModal.show()">Cancel subscription</b-button>
							<b-button variant="primary" v-else-if="!user.is_subscribed || user.subscription_status == 'gratuity'" @click="$refs.purchaseModal.show('regular', 'yearly')">Buy yearly</b-button>
						</th>
						<th :class="{'table-secondary': user.is_pro && user.is_monthly, 'text-secondary': user.is_pro && user.is_monthly, 'text-center': true}">
							<b-button variant="danger" v-if="user.is_pro && user.is_monthly && user.subscription_status != 'gratuity'" @click="$refs.cancelModal.show()">Cancel subscription</b-button>
							<b-button variant="primary" v-else-if="!user.is_subscribed || user.subscription_status == 'gratuity'" @click="$refs.purchaseModal.show('pro', 'monthly')" :disabled="!enablePro" :style="{ cursor: enablePro?'':'not-allowed' }" v-b-tooltip.hover.bottom :title="enablePro ? '' : 'Option currently disabled'">Buy monthly</b-button>
						</th>
						<th :class="{'table-secondary': user.is_pro && user.is_yearly, 'text-secondary': user.is_pro && user.is_yearly, 'text-center': true}">
							<b-button variant="danger" v-if="user.is_pro && user.is_yearly && user.subscription_status != 'gratuity'" @click="$refs.cancelModal.show()">Cancel subscription</b-button>
							<b-button variant="primary" v-else-if="!user.is_subscribed || user.subscription_status == 'gratuity'" @click="$refs.purchaseModal.show('pro', 'yearly')" :disabled="!enablePro" :style="{ cursor: enablePro?'':'not-allowed' }" v-b-tooltip.hover.bottom :title="enablePro ? '' : 'Option currently disabled'">Buy yearly</b-button>
						</th>
					</tr>
				</tfoot>
			</table>

<!-- 			<h3>Previous payments</h3>
			<b-table :items="payments" :fields="['plan','price','quantity','payment_date','expiration_date']"></b-table>
 -->		</div>
		<div v-else>
			No user data.
		</div>

		<account-purchase-modal ref="purchaseModal" @success="loadBillingData"></account-purchase-modal>
		<account-cancel-modal ref="cancelModal"></account-cancel-modal>
	</div>
</template>

<script>
import AccountPurchaseModal from '../../components/Account/Modal/Purchase';
import AccountCancelModal from '../../components/Account/Modal/Cancel';

export default {
	components: {
		AccountPurchaseModal,
		AccountCancelModal,
	},
	data: () => ({
		loading: 0,
		error: null,
		user: null,
		enablePro: true,
		payments: [
			{ plan: 'regular', price: '$4', quantity: 1, payment_date: '2023-10-25', expiration_date: '2023-11-25' },
		],
	}),
	mounted() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		this.loadBillingData().then(user => {
			this.subId = this.$socket.subscribe(user.widget_hash, {
				userChanged: msg => this.user = { ...this.user, ...msg },
			});

			if(params.plan && params.period)
				this.$refs.purchaseModal.show(params.plan, params.period);
		});
	},
	beforeDestroy() {
		this.subId && this.$socket.unsubscribe(this.subId);
	},
	methods: {
		setUserBillingData(data) {
			this.user = data;
			this.user.is_subscribed = this.user.has_subscription_id && (this.user.subscription_status == 'active' || this.user.subscription_status == 'active') || this.user.subscription_status == 'gratuity';
			this.user.is_monthly = this.user.is_subscribed && this.user.period == 'monthly';
			this.user.is_yearly = this.user.is_subscribed && this.user.period == 'yearly';
			this.user.is_regular = this.user.is_subscribed && this.user.plan == 'regular';
			this.user.is_pro = this.user.is_subscribed && this.user.plan == 'pro';
		},
		loadBillingData() {
			this.loading++;
			return this.$api.get('userData').then(user => {
				this.setUserBillingData(user);
				return user;
			}, err => this.error = err).finally(() => this.loading--);
		},
	},
}
</script>
